import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (event) => {
    event.preventDefault(); setLoading(true); setError('');
    try { const { data } = await api.post('/users/forgot-password', { email }); setMessage(data.message); }
    catch (err) { setError(err.response?.data?.message || 'No fue posible enviar la solicitud.'); }
    finally { setLoading(false); }
  };
  return <div className="min-h-screen bg-[#F8FCFA] pt-28 px-4"><form onSubmit={submit} className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-7">
    <h1 className="text-2xl font-bold text-[#0C4B45]">Recuperar contraseña</h1><p className="text-sm text-gray-600 mt-2 mb-6">Te enviaremos un enlace seguro para crear una nueva contraseña.</p>
    {message && <p className="rounded-lg bg-green-50 text-green-800 p-3 text-sm mb-4">{message}</p>}{error && <p className="rounded-lg bg-red-50 text-red-700 p-3 text-sm mb-4">{error}</p>}
    <label className="block text-sm font-medium mb-2">Correo electrónico</label><input type="email" required autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0C4B45]" placeholder="tu@correo.com" />
    <button disabled={loading} className="w-full mt-5 bg-[#0C4B45] text-white rounded-xl py-3 font-semibold disabled:opacity-60">{loading ? 'Enviando…' : 'Enviar enlace'}</button>
    <Link className="block text-center text-sm text-[#0C4B45] mt-5 hover:underline" to="/login">Volver a iniciar sesión</Link>
  </form></div>;
}
